<template>
<g class="hc-hexapoint" :transform="transform">
  <text
    class="hc-hexapoint-text"
    dy="-34"
    text-anchor="middle"
    :fill="color"
  >
    {{text}}{{unit}}
  </text>
  <hexagon
    class="hc-hexapoint-hexagon"
    :fill="color"
    :stroke="color"/>
</g>
</template>

<script>
import Hexagon from '../shapes/Hexagon'
export default {
  name: 'HexaPoint',
  components: {
    Hexagon
  },
  props: {
    color: {
      type: String,
      default: '#f56043'
    },
    x: {
      type: Number,
      default: 0
    },
    y: {
      type: Number,
      default: 0
    },
    text: {
      type: String,
      default: ''
    },
    unit: {
      type: String,
      default: '%'
    },
    scale: {
      type: Number,
      default: 1
    }
  },
  computed: {
    transform () {
      return `translate(${this.x}, ${this.y}) scale(${this.scale})`
    }
  }
}
</script>

<style>

</style>
